/**
 * City PDP — nearby same-type workshops ("not your city?" panel).
 * Catalog: optional API on first panel open, Liquid embed fallback.
 */
(function () {
  var API = typeof window !== 'undefined' ? window.WorkshopCityEvents : null;
  var FETCH_TIMEOUT_MS =
    API && API.DEFAULT_FETCH_TIMEOUT_MS ? API.DEFAULT_FETCH_TIMEOUT_MS : 15000;

  function haversineKm(lat1, lng1, lat2, lng2) {
    var r = 6371;
    var dLat = ((lat2 - lat1) * Math.PI) / 180;
    var dLng = ((lng2 - lng1) * Math.PI) / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    return r * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function readData(sectionId) {
    var el = document.getElementById('CityWorkshopNearbyData-' + sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '');
    } catch (e) {
      console.warn('[city-workshop-nearby] bad JSON', e);
      return null;
    }
  }

  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatDistance(km, useMiles) {
    if (!Number.isFinite(km)) return '';
    if (useMiles) {
      var mi = km * 0.621371;
      if (mi < 10) return Math.round(mi) + ' mi';
      return Math.round(mi) + ' miles';
    }
    if (km < 10) return Math.round(km) + ' km';
    return Math.round(km) + ' km';
  }

  function buildNearbyList(data) {
    var originLat = Number(data.lat);
    var originLng = Number(data.lng);
    var hasOrigin = Number.isFinite(originLat) && Number.isFinite(originLng);
    var maxRadius = Number(data.maxRadiusKm) || 200;
    var maxResults = Number(data.maxResults) || 8;
    var type = String(data.workshopType || '').toLowerCase();
    var cityKey = String(data.cityName || '').toLowerCase().trim();
    var selfId = Number(data.productId);

    var items = (data.products || [])
      .filter(function (p) {
        if (!p || Number(p.id) === selfId) return false;
        if (String(p.workshopType || '').toLowerCase() !== type) return false;
        if (String(p.cityName || '').toLowerCase().trim() === cityKey) return false;
        if (!hasOrigin) return true;
        var lat = Number(p.lat);
        var lng = Number(p.lng);
        return Number.isFinite(lat) && Number.isFinite(lng);
      })
      .map(function (p) {
        var dist = null;
        if (hasOrigin && Number.isFinite(Number(p.lat)) && Number.isFinite(Number(p.lng))) {
          dist = haversineKm(originLat, originLng, Number(p.lat), Number(p.lng));
        }
        return { product: p, distanceKm: dist };
      })
      .filter(function (item) {
        if (!hasOrigin) return true;
        return item.distanceKm != null && item.distanceKm <= maxRadius;
      });

    items.sort(function (a, b) {
      if (a.distanceKm == null && b.distanceKm == null) return a.product.cityName.localeCompare(b.product.cityName);
      if (a.distanceKm == null) return 1;
      if (b.distanceKm == null) return -1;
      return a.distanceKm - b.distanceKm;
    });

    return items.slice(0, maxResults);
  }

  function renderCard(item, useMiles) {
    var p = item.product;
    var dist = formatDistance(item.distanceKm, useMiles);
    var img = p.featuredImageUrl
      ? '<img class="cwn-nearby-card__img" src="' + esc(p.featuredImageUrl) + '" alt="" loading="lazy" width="72" height="72">'
      : '<span class="cwn-nearby-card__img cwn-nearby-card__img--placeholder" aria-hidden="true"></span>';
    return (
      '<a href="' +
      esc(p.url) +
      '" class="cwn-nearby-card" role="listitem">' +
      img +
      '<span class="cwn-nearby-card__body">' +
      '<span class="cwn-nearby-card__city">' +
      esc(p.cityName) +
      '</span>' +
      '<span class="cwn-nearby-card__meta">' +
      esc(p.workshopLabel || p.workshopType) +
      (dist ? ' · ' + esc(dist) : '') +
      '</span>' +
      '</span>' +
      '</a>'
    );
  }

  function paintList(list, empty, data, items) {
    if (!items.length) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    list.innerHTML = items
      .map(function (item) {
        return renderCard(item, data.useMiles !== false);
      })
      .join('');
  }

  function shouldUseApi(root) {
    return root.getAttribute('data-use-api') === 'true';
  }

  function loadCatalog(root, liquidData) {
    API = window.WorkshopCityEvents || API;
    if (!shouldUseApi(root) || !API || typeof API.fetchNearbyCatalog !== 'function') {
      return Promise.resolve(null);
    }
    return API.fetchNearbyCatalog(root, FETCH_TIMEOUT_MS).catch(function (err) {
      console.warn('[city-workshop-nearby] API failed, using Liquid fallback', err);
      return null;
    });
  }

  function initRoot(root) {
    var sectionId = root.getAttribute('data-section-id');
    var data = readData(sectionId);
    if (!data) return;

    var trigger = root.querySelector('[data-cwn-trigger]');
    var panel = root.querySelector('[data-cwn-panel]');
    var list = root.querySelector('[data-cwn-list]');
    var empty = root.querySelector('[data-cwn-empty]');
    if (!trigger || !panel || !list) return;

    var rendered = false;
    var catalogLoading = false;

    function renderPanel() {
      if (rendered || catalogLoading) return;

      if (!shouldUseApi(root) || !(window.WorkshopCityEvents && window.WorkshopCityEvents.fetchNearbyCatalog)) {
        rendered = true;
        paintList(list, empty, data, buildNearbyList(data));
        return;
      }

      catalogLoading = true;
      list.innerHTML = '<p class="cwn-nearby__loading" aria-live="polite">Loading…</p>';
      if (empty) empty.hidden = true;

      loadCatalog(root, data).then(function (apiProducts) {
        var catalogData = data;
        if (apiProducts && apiProducts.length) {
          catalogData = Object.assign({}, data, { products: apiProducts });
        }
        rendered = true;
        catalogLoading = false;
        paintList(list, empty, catalogData, buildNearbyList(catalogData));
      });
    }

    trigger.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('cwn-nearby--open', open);
      if (open) renderPanel();
    });
  }

  function boot() {
    document.querySelectorAll('[data-city-workshop-nearby]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
